<template>
  <main id="page-reset-password" class="news-page">
    <header class="masthead">
      <div class="masthead__rule masthead__rule--thick"></div>
      <div class="masthead__rule masthead__rule--thin"></div>
      <div class="masthead__inner">
        <p class="masthead__kicker">Platforma Română de</p>
        <h1 class="masthead__title">Sondaje de Opinie</h1>
        <p class="masthead__tagline">Voce. Date. Adevăr.</p>
      </div>
      <div class="masthead__rule masthead__rule--thick"></div>
    </header>

    <section class="auth-card reset-password-card">
      <h2 class="reset-password-card__title">Setare parolă nouă</h2>

      <div v-if="successMessage" class="auth-card__message">
        {{ successMessage }}
        <div class="reset-password-card__back">
          <button type="button" class="auth-form__forgot-link" @click="$router.push({ name: 'home' })">
            Mergeți la autentificare
          </button>
        </div>
      </div>

      <div v-else-if="!token || !email" class="auth-card__error">
        Link invalid sau expirat. Solicitați un nou link de resetare.
        <div class="reset-password-card__back">
          <button type="button" class="auth-form__forgot-link" @click="$router.push({ name: 'forgot-password' })">
            Recuperare parolă
          </button>
        </div>
      </div>

      <div v-else>
        <p class="reset-password-card__desc">
          Setați o parolă nouă pentru contul asociat cu <strong>{{ email }}</strong>.
        </p>

        <form class="auth-form" @submit.prevent="submit">
          <FormField
            v-model="password"
            type="password"
            label="Parolă nouă"
            placeholder="••••••••"
            :errors="errors.password"
          />

          <FormField
            v-model="passwordConfirmation"
            type="password"
            label="Confirmați parola"
            placeholder="••••••••"
            :errors="errors.password_confirmation"
          />

          <div v-if="errorMessage" class="auth-card__error">{{ errorMessage }}</div>

          <button type="submit" class="auth-form__submit" :disabled="isSubmitting">
            {{ isSubmitting ? 'Se procesează...' : 'Salvează parola nouă' }}
          </button>
        </form>

        <div class="reset-password-card__back">
          <button type="button" class="auth-form__forgot-link" @click="$router.push({ name: 'home' })">
            ← Înapoi la autentificare
          </button>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import FormField from '../../components/FormField.vue';

export default {
  name: 'ResetPasswordView',
  components: { FormField },

  data() {
    return {
      token: '',
      email: '',
      password: '',
      passwordConfirmation: '',
      isSubmitting: false,
      successMessage: '',
      errorMessage: '',
      errors: {},
    };
  },

  mounted() {
    this.token = this.$route.query.token || '';
    this.email = this.$route.query.email || '';
  },

  methods: {
    async submit() {
      this.isSubmitting = true;
      this.errorMessage = '';
      this.errors = {};

      try {
        const response = await window.axios.post('/auth/reset-password', {
          token: this.token,
          email: this.email,
          password: this.password,
          password_confirmation: this.passwordConfirmation,
        });

        this.successMessage = response.data.message || 'Parola a fost resetată cu succes. Vă puteți autentifica acum.';
      } catch (err) {
        if (err.response?.status === 422) {
          const data = err.response.data;
          if (data.errors) {
            this.errors = data.errors;
          } else {
            this.errorMessage = data.message || 'A apărut o eroare. Încercați din nou.';
          }
        } else {
          this.errorMessage = 'A apărut o eroare. Încercați din nou.';
        }
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>
